import { render, staticRenderFns } from "./reload.vue?vue&type=template&id=64aa21b9&scoped=true&"
import script from "./reload.vue?vue&type=script&lang=js&"
export * from "./reload.vue?vue&type=script&lang=js&"
import style0 from "./reload.vue?vue&type=style&index=0&id=64aa21b9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aa21b9",
  null
  
)

export default component.exports